<template>
  <div :id="loadingPage" class="vs-con-loading__container">
    <document-modal
      v-model="displayModal"
      :frequencies="frequencies"
      :item="item"
      @refresh="getData"
      ></document-modal>
    <div class="flex mb-4">
      <div class="w-full">
        <vs-card>
          <documents-table
            :data="data"
            @add="addItem"
            @edit="editItem"
            @loadMore="loadMore"
            @search="search"
          />
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentsTable from './components/DocumentsTable.vue'
import DocumentModal from './components/DocumentModal.vue'
import document from '../requests/document'
import loading from '@/mixins/Loading'

export default {
  components: {
    DocumentsTable,
    DocumentModal,
  },
  computed: {
    isLoading() {
      return this.loading.data || this.loading.frequencies
    },
  },
  data() {
    return {
      data: [],
      displayModal: false,
      frequencies: [],
      item: {},
      lastPage:'1',
      loading: {
        data: false,
        frequencies: false,
      },
      loadingPage: 'repse-documents-loading',
      params:{
        search:'',
        page:1
      }
    }
  },
  methods: {
    addItem: function () {
      this.item = Object.assign({})
      this.displayModal = true
    },
    editItem: function (data) {
      this.item = data
      this.displayModal = true
    },
    getData: function () {
      this.loading.data = true
      document
        .list(this.params)
        .then((response) => {
          this.data = response.data.data
          this.lastPage = response.data.last_page
          this.loading.data = false
        })  
        .catch((response) => {
          this.showValidationErrors(response)
          this.loading.data = false
        })
    },
    getFrequencies: function () {
      this.loading.frequencies = true
      document
        .getFrequencies()
        .then((response) => {
          this.frequencies = response.data.frequencies
          this.loading.frequencies = false
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.loading.frequencies = false
        })
    },
    loadMore: function () {
      return
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getData()
    },
    search: function (text = '') {
      this.params.search = text
      this.params.page = 1
      this.getData()
    },
  },
  mixins: [loading],
  mounted() {
    this.getData()
    this.getFrequencies()
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(this.loadingPage)
      } else {
        this.closeLoading(this.loadingPage)
      }
    },
  },
}
</script>

<style>
</style>